import React from 'react';
import { useTransition, animated } from 'react-spring';
import { TRANSITION_DECELERATE } from '@nokia-csf-uxr/freeform-design-tokens/tokens/transition';
import { SPEED_SLOW } from '@nokia-csf-uxr/freeform-design-tokens/tokens/speed';
import { getContext, getEasing, getDuration, isAnimationDisabled } from 'common';

const TRANSITION_RIGHT = { opacity: 0, transform: 'translateX(-100%)' };
const TRANSITION_LEFT = { opacity: 0, transform: 'translateX(100%)' };
const TRANSITION_RIGHT_DISPLAY_NONE = { opacity: 0, transform: 'translateX(-100%)' };
const TRANSITION_LEFT_DISPLAY_NONE = { opacity: 0, transform: 'translateX(100%)' };

export interface CarouselAnimationProps extends React.ComponentPropsWithRef<'div'> {
  /**  Content of the Carousel */
  children: React.ReactNode;
  /** Control animation config here. This uses react-spring transitions config. See https://react-spring.io for more information. */
  animationProps?: any;
  /** If true, disable all motion animation. This property will override any global disableAnimation setting. */
  disableAnimation?: boolean;
  activeIndex: number;
  /** RTL */
  animateRight: boolean;
}

const CarouselAnimation = ({
  children,
  activeIndex,
  animateRight,
  animationProps,
  disableAnimation: propsdisableAnimation,
}: CarouselAnimationProps) => getContext(({ disableAnimation }) => {
  const fromValue = animateRight ? TRANSITION_RIGHT : TRANSITION_LEFT;
  const leaveValue = animateRight ? TRANSITION_LEFT_DISPLAY_NONE : TRANSITION_RIGHT_DISPLAY_NONE;
  const defaultAnimationConfig = {
    config: {
      duration: getDuration(SPEED_SLOW),
      easing: getEasing(TRANSITION_DECELERATE)
    },
    immediate: isAnimationDisabled(propsdisableAnimation, disableAnimation),
    from: fromValue,
    enter: { opacity: 1, transform: 'translateX(0%)' },
    leave: leaveValue
  };
  const transitions = useTransition(activeIndex, null, animationProps || defaultAnimationConfig);
  return (
    <>
      {transitions.map(({ item, key, props }) => (
        <animated.div key={key} style={{ position: 'absolute' as const, width: '100%', ...props }}>
          {children[item]}
        </animated.div>
      ))}
    </>);
});

CarouselAnimation.defaultProps = {
  animationProps: undefined,
  disableAnimation: undefined,
};
CarouselAnimation.displayName = 'CarouselAnimation';
export default CarouselAnimation;
